import { Component, OnInit, ViewChild } from "@angular/core";
import { ScanReminderTableComponent } from "./scan-reminder-table/scan-reminder-table.component";

@Component({
	selector: "app-scan-station-reminder-setup",
	templateUrl: "./scan-station-reminder-setup.component.html",
	styleUrls: ["./scan-station-reminder-setup.component.css"],
})
export class ScanStationReminderSetupComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {}

	/////////////////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////////////////

	SelectedStationReminderAlert: any = null;

	@ViewChild(ScanReminderTableComponent)
	mainRef: ScanReminderTableComponent;

	/////////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////////
	// Events
	/////////////////////////////////////////////////////////////////////////

	onReminderSelected(val) {
		this.SelectedStationReminderAlert = val;
	}

	onPersonTableUpdated(val) {
		this.mainRef.onRefresh();
	}

	/////////////////////////////////////////////////////////////////////////
}
